// extracted by mini-css-extract-plugin
export default {"wrapper":"GazettePage_wrapper__2NEgc","pageHeader":"GazettePage_pageHeader__N3nIf","pageTitle":"GazettePage_pageTitle__ggkDu","pageSubtitle":"GazettePage_pageSubtitle__uIQYp"};